import {
  doc,
  runTransaction
} from "firebase/firestore";

import { db } from "../../../firebase";

/*

  PO NUMBER FORMAT

  PO-2026-0001

*/

export const generatePONumber = async () => {

  try {

    const year =
      new Date().getFullYear();

    const counterRef = doc(

      db,

      "system_counters",

      `po_${year}`

    );

    const poNumber =
      await runTransaction(

        db,

        async (transaction) => {

          const counterSnap =
            await transaction.get(
              counterRef
            );

          let nextNumber = 1;

          // EXISTING COUNTER

          if (counterSnap.exists()) {

            const data =
              counterSnap.data();

            nextNumber =
              (data.last_number || 0) + 1;
          }

          // UPDATE COUNTER

          transaction.set(

            counterRef,

            {

              counter_type:
                "purchase_order",

              year,

              last_number:
                nextNumber,

              updated_at:
                new Date()

            },

            { merge: true }

          );

          // FORMAT

          const formattedNumber =
            String(nextNumber).padStart(
              4,
              "0"
            );

          return `PO-${year}-${formattedNumber}`;
        }

      );

    console.log(
      "Generated PO Number:",
      poNumber
    );

    return poNumber;

  } catch (error) {

    console.error(

      "PO number generation failed",

      error

    );

    throw error;
  }
};

/*

  OPTIONAL TEST FUNCTION

*/

export const testPONumberGeneration =
  async () => {

    try {

      const poNumber =
        await generatePONumber();

      alert(
        `Generated: ${poNumber}`
      );

    } catch (error) {

      console.error(error);

      alert(
        "PO number generation failed"
      );
    }
  };